import CardDesignerCardElementText from './CardDesignerCardElementText';

export default CardDesignerCardElementText;
